import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { FlexRowCenter } from '../../../components/LayoutBoxes';
import { dialogStyles as styles } from '../styles/dialogStyles';
import { BaseDialog } from './BaseDialog';

interface PatientConsentDialogProps {
  open: boolean;
  onConsent: (doNotShowAgain: boolean) => void;
  onCancel: () => void;
}

export const PatientConsentDialog: React.FC<PatientConsentDialogProps> = ({
  open,
  onConsent,
  onCancel,
}) => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const handleConsent = () => {
    onConsent(doNotShowAgain);
  };

  return (
    <BaseDialog open={open} onClose={() => {}} showCloseButton={false}>
      <Box sx={styles.consentContainer}>
        <Typography
          variant='dialogTitle'
          component='h2'
          sx={styles.consentTitle}
        >
          Patient Consent Required
        </Typography>

        <Typography variant='dialogBody' component='p' sx={styles.consentBodyText}>
          By continuing, you confirm that the patient has given consent to be
          recorded. AI Scribe records the encounter to generate clinical
          documentation.
        </Typography>

        <FlexRowCenter sx={styles.consentCheckboxContainer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={doNotShowAgain}
                onChange={(e) => setDoNotShowAgain(e.target.checked)}
                size='small'
                sx={styles.consentCheckbox}
              />
            }
            label={
              <Typography variant='helperText' sx={styles.consentLabelText}>
                Do not show again
              </Typography>
            }
            sx={styles.consentCheckboxLabel}
          />
        </FlexRowCenter>

        <FlexRowCenter sx={styles.consentButtonContainer}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleConsent}
            size='small'
            sx={styles.consentPrimaryButton}
          >
            Continue
          </Button>
          <Button
            variant='outlined'
            onClick={onCancel}
            size='small'
            sx={styles.consentSecondaryButton}
          >
            Cancel
          </Button>
        </FlexRowCenter>
      </Box>
    </BaseDialog>
  );
};
